<script lang="ts">
    import Link from "svelte-link/src/Link.svelte";
    import { Card, CardBody, Col } from "sveltestrap";
    import UserIncome from "../../../Data/ComponentData/DashboardData/Defaultdata/UserIncome.json";
    import * as SvgIcon from "../../../Data/SvgIcon/SvgIcon";
    import {href} from "../../../utils/Constant/Constant"
</script>

{#each UserIncome.Userincome as userItem}
    <Col xl="6" md="3" sm="6" class="box-col-3 des-xl-25 rate-sec">
        <Card class="income-card card-{userItem.class}">
            <CardBody class="text-center">
                <div class="round-box">
                    {@html SvgIcon[userItem.svg]}
                </div>
                <h5>{userItem.income}</h5>
                <p>{userItem.title}</p>
                <Link class="btn-arrow arrow-{userItem.class}" href={href}>
                    <i class="toprightarrow-{userItem.class} fa fa-arrow-up me-2"/>{userItem.percentage}
                </Link>
                <div class="parrten">
                    {@html SvgIcon[userItem.svg]}
                </div>
            </CardBody>
        </Card>
    </Col>
{/each}
